import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="keyboard-inset"
//
// Exposes the height of the on-screen keyboard as the `--keyboard-inset` CSS variable on its element, so that
// elements fixed to the bottom of the page can stay above it. iOS Safari doesn't resize the layout viewport when the
// keyboard opens, so fixed elements end up hidden behind it.
export default class KeyboardInsetController extends Controller<HTMLElement> {
  connect() {
    window.visualViewport?.addEventListener("resize", this.#update)
    window.visualViewport?.addEventListener("scroll", this.#update)
    this.#update()
  }

  disconnect() {
    window.visualViewport?.removeEventListener("resize", this.#update)
    window.visualViewport?.removeEventListener("scroll", this.#update)
    this.element.style.removeProperty("--keyboard-inset")
  }

  #update = () => {
    const viewport = window.visualViewport
    if (!viewport) return

    const inset = Math.max(0, window.innerHeight - viewport.height - viewport.offsetTop)
    this.element.style.setProperty("--keyboard-inset", `${inset}px`)
  }
}
